/** @format */

import {StarOutline} from '@mui/icons-material';

import {ColumnType} from 'components/Table/core/types';

import {BlueButton} from 'components/buttons/BlueButton';

import {toStr} from 'helpers/stringHelpers';

import {ReportBox, StatusChip} from '../styles';
import ActionsMenu from '../components/ActionsMenu';
import {AI_REPORT_STATUS} from '../constants';

export const formatColumns = (
  onClickGrade: (id: string, reportName: string) => void,
  onReportView?: (reportId: string) => void,
): ColumnType[] => {
  return [
    {
      id: 'reportName',
      title: 'Отчет',
      size: 300,
      cell: info => {
        const data = info.row.original;
        const isReady = data.status === 'success' && !data.hasFeedback;
        const reportName = getReportName(data.companyName as string, data.reportDate as string);

        return (
          <ReportBox>
            {reportName}
            {isReady && (
              <BlueButton onClick={() => onClickGrade(data.id as string, reportName)}>
                <StarOutline />
                Оценить отчет
              </BlueButton>
            )}
          </ReportBox>
        );
      },
    },
    {
      id: 'status',
      title: 'Статус',
      size: 140,
      sortingFn: 'alphanumeric',
      cell: info => {
        const data = info.row.original;
        const status = data.status as keyof typeof AI_REPORT_STATUS;
        return (
          <StatusChip label={data.status as string}>
            {AI_REPORT_STATUS[status] || 'Новый'}
          </StatusChip>
        );
      },
    },
    {
      id: 'viewAction',
      title: 'Открыть',
      size: 120,
      cell: info => {
        const data = info.row.original;

        if (data.status !== 'success') {
          return null;
        }

        return <ActionsMenu reportId={toStr(data.id)} onReportView={onReportView} />;
      },
    },
  ];
};

const getReportName = (companyName: string, reportDate: string) => {
  const date = new Date(reportDate);
  const formatted = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
  return `${companyName} — Отчет ${formatted}`;
};
